import section4Img from "./section4_img.webp";
import classes from "./Section4.module.css";
import { section4Data } from "../../../data/home";

export default function Section4() {
  return (
    <section className={classes.section}>
      <div className={classes.panel}>
        <div className={classes.imageWrap}>
          <img
            src={section4Img}
            alt="Flow 7 autonomic neuropathy and vascular dysfunction testing"
            className={classes.media}
            loading="lazy"
          />
        </div>

        <div className={classes.content}>
          <div className={classes.inner}>
            <p className={classes.subtitle}>
              Autonomic Neuropathy &amp; Vascular Dysfunction Testing
            </p>

            <h2 className={classes.heading}>
              Key Features Of Flow 7
            </h2>

            <p className={classes.paragraph}>
              Flow 7 combines advanced testing technology with connected
              healthcare tools to help providers identify vascular and autonomic
              issues early, access results quickly, and coordinate care more
              effectively.
            </p>

            <div className={classes.features}>
              {section4Data.map((feature, index) => (
                <article
                  key={feature.title}
                  className={classes.feature}
                >
                  <span className={classes.featureIcon} aria-hidden="true">
                    {feature.icon}
                  </span>

                  <div className={classes.featureText}>
                    <h3 className={classes.featureTitle}>{feature.title}</h3>

                    <p className={classes.featureDescription}>
                      {feature.description}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
